import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import globalTranslations from '../../../i18n/globalTranslations';
import Icon from '../Icon';
import RegionalSettingsDropdowns from '../RegionalSettingsDropdowns';

const RegionalSettingsDialogContent = ({
  currentValues,
  onChange,
  errorState,
  isSaving,
  onSave,
  onClose,
  titleId,
  contentRef,
  onContentKeyDown,
  contentTabIndex,
}) => {
  const { hasError, message } = errorState;

  return (
    <>
      <ModalHeader
        className="RegionalSettingsDialogContent__header"
        toggle={onClose}
        tag="h2"
        id={titleId}
      >
        <FormattedMessage {...globalTranslations.regionalSettingsTitle} />
      </ModalHeader>
      <ModalBody className="RegionalSettingsDialogContent__body">
        <div
          ref={contentRef}
          className="RegionalSettingsDialogContent__content"
          tabIndex={contentTabIndex}
          onKeyDown={onContentKeyDown}
        >
          <RegionalSettingsDropdowns {...currentValues} onChange={onChange} />
          {hasError && (
            <div
              className="RegionalSettingsDialogContent__error"
              role="alert"
              aria-live="assertive"
            >
              {message || (
                <FormattedMessage {...globalTranslations.errorContent} />
              )}
            </div>
          )}
        </div>
      </ModalBody>
      <ModalFooter className="RegionalSettingsDialogContent__footer">
        <Button
          className="RegionalSettingsDialogContent__save-button"
          color="primary"
          disabled={isSaving}
          onClick={onSave}
        >
          <span>
            <Icon
              name={isSaving ? 'circle-o-notch' : 'check'}
              spin={isSaving}
            />{' '}
            <FormattedMessage {...globalTranslations.saveTitle} />
          </span>
        </Button>
      </ModalFooter>
    </>
  );
};

RegionalSettingsDialogContent.propTypes = {
  currentValues: PropTypes.shape({
    country: PropTypes.object,
    currency: PropTypes.object,
    language: PropTypes.object,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  errorState: PropTypes.shape({
    hasError: PropTypes.bool.isRequired,
    message: PropTypes.string,
  }).isRequired,
  isSaving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  titleId: PropTypes.string,
  contentRef: PropTypes.shape({ current: PropTypes.any }),
  onContentKeyDown: PropTypes.func,
  contentTabIndex: PropTypes.number,
};

RegionalSettingsDialogContent.defaultProps = {
  onClose: undefined,
  titleId: undefined,
  contentRef: undefined,
  onContentKeyDown: undefined,
  contentTabIndex: undefined,
};

export default RegionalSettingsDialogContent;
